import { Col, Form, Input, Row } from "antd"
import { useContext, useEffect } from "react"
import LayoutCommon from "src/components/Common/LayoutCommon"
import ButtonCustom from "src/components/MyButton/Button"
import notice from "src/components/Notice"
import { StoreContext } from "src/contexts"
import { getRegexEmail, getRegexMobile } from "src/lib/stringsUtils"
import GuestService from "src/services/GuestService"
import "./index.scss"
const Contact = () => {
  const { userStore } = useContext(StoreContext)
  const { user } = userStore
  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        name: user.FullName || "",
        phoneNumber: user.PhoneNumber || "",
        email: user.Email || "",
        address: user.Address || "",
      })
    }
  }, [user])

  const [form] = Form.useForm()
  const onFinish = values => {
    const send = async () => {
      try {
        const response = await GuestService.SendContact(values)
        if (response?.isOk) {
          form.resetFields()
          notice({
            msg: "Gửi yêu cầu hỗ trợ thành công!",
            isSuccess: true,
          })
        }
      } catch (error) {
        console.log("Error sending contact:", error)
      }
    }
    send()
  }
  const onFinishFailed = errorInfo => {
    console.log("Failed:", errorInfo)
  }

  return (
    <LayoutCommon>
      <div className="home__contact">
        <h1 className="hero-title">Liên hệ hỗ trợ</h1>
        <Form
          labelAlign="left"
          layout="vertical"
          className="home__contact--form mb-20"
          onFinish={onFinish}
          form={form}
          onFinishFailed={onFinishFailed}
          initialValues={user}
        >
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item
                name="FullName"
                label="Họ và Tên"
                labelAlign="left"
                rules={[
                  { required: true, message: "Vui lòng nhập họ và tên!" },
                ]}
              >
                <Input
                  placeholder="Nhập họ và tên của bạn"
                  disabled={user && user.FullName}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="PhoneNumber"
                label="Số Điện Thoại"
                labelAlign="left"
                rules={[
                  { required: true, message: "Vui lòng nhập số điện thoại!" },
                  {
                    pattern: getRegexMobile(),
                    message:
                      "Số điện thoại là chuỗi từ 9 đến 15 chữ số, bắt đầu bằng 0",
                  },
                ]}
              >
                <Input
                  placeholder="Nhập số điện thoại"
                  disabled={user && user.PhoneNumber}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="Email"
                label="E-mail"
                labelAlign="left"
                rules={[
                  { required: true, message: "Vui lòng nhập email" },
                  {
                    pattern: getRegexEmail(),
                    message: "Email không đúng định dạng (vd: ten@domain.com)",
                  },
                ]}
              >
                <Input placeholder="Nhập email" disabled={user && user.Email} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="Address"
                label="Địa Chỉ"
                labelAlign="left"
                rules={[{ required: true, message: "Vui lòng nhập địa chỉ!" }]}
              >
                <Input
                  placeholder="Nhập địa chỉ"
                  disabled={user && user.Address}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="Content"
                label="Nội dung"
                rules={[
                  { required: true, message: "Nội dung không được để trống" },
                ]}
                labelAlign="left"
              >
                <Input.TextArea rows={10} placeholder="Nhập nội dung" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <ButtonCustom
                type="primary"
                htmlType="submit"
                style={{
                  backgroundColor: "#01b39e",
                  color: "white",
                  borderRadius: 20,
                  height: 40,
                }}
              >
                Gửi
              </ButtonCustom>
            </Col>
          </Row>
        </Form>
      </div>
    </LayoutCommon>
  )
}

export default Contact
